import { render } from "./ProductDetailAttributes.vue?vue&type=template&id=2b58dc34&scoped=true"
import script from "./ProductDetailAttributes.vue?vue&type=script&lang=js"
export * from "./ProductDetailAttributes.vue?vue&type=script&lang=js"

import "./ProductDetailAttributes.vue?vue&type=style&index=0&id=2b58dc34&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b58dc34"]])

export default __exports__